function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 340 340",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1314_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1315_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1316_",
    style: {
      fill: "#1F2C47"
    },
    d: "M244.645,340H56.619C41.941,340,30,328.059,30,313.381V26.619 C30,11.941,41.941,0,56.619,0h226.762C298.059,0,310,11.941,310,26.619v248.025L244.645,340z M56.619,20 C52.969,20,50,22.97,50,26.619v286.762c0,3.649,2.969,6.619,6.619,6.619H236.36L290,266.359V26.619 c0-3.649-2.969-6.619-6.619-6.619H56.619z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1319_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1320_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1321_",
    x: 190.803,
    y: 194.641,
    style: {
      fill: "#1F2C47"
    },
    width: 67.394,
    height: 20
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1322_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1323_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1324_",
    style: {
      fill: "#1F2C47"
    },
    d: "M173.04,214.307h-20v-44.22h-50.63v44.22h-20v-46.943 c0-9.526,7.75-17.276,17.277-17.276h56.076c9.526,0,17.277,7.75,17.277,17.276L173.04,214.307L173.04,214.307z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1325_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    style: {
      fill: "#00969B"
    },
    d: "M239.47,126.64H102.137c-5.372,0-9.727-4.355-9.727-9.727V65.42 c0-5.372,4.355-9.727,9.727-9.727H239.47c5.372,0,9.727,4.355,9.727,9.727v51.494C249.197,122.286,244.842,126.64,239.47,126.64 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1326_",
    style: {
      fill: "#1F2C47"
    },
    d: "M239.47,136.641H102.137c-10.877,0-19.727-8.85-19.727-19.727V65.42 c0-10.877,8.849-19.727,19.727-19.727H239.47c10.877,0,19.727,8.85,19.727,19.727v51.494 C259.197,127.791,250.347,136.641,239.47,136.641z M102.41,116.641h136.787V65.693H102.41V116.641z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1329_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1330_",
    x: 190.803,
    y: 154.641,
    style: {
      fill: "#1F2C47"
    },
    width: 67.394,
    height: 20
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1331_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1332_",
    x: 82.41,
    y: 274.307,
    style: {
      fill: "#1F2C47"
    },
    width: 67.393,
    height: 20
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1333_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1334_",
    x: 81.803,
    y: 234.974,
    style: {
      fill: "#1F2C47"
    },
    width: 176.394,
    height: 20
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.fc15f1a4ba6d2de263d6ea0512e1445b.svg";
export { ForwardRef as ReactComponent };